var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"p-inner"},[_c('pageHeader'),_c('pageTips',{attrs:{"tip":_vm.tip}}),_c('pageProj',{attrs:{"info":_vm.info}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }